import styles from "../FirstProductPrompt/FirstProductPrompt.module.scss";
import { Button } from "@blueprintjs/core";
import React from "react";

function FirstVideoPrompt({ selectedTab, onAddVideoClick }) {
  const cardTitle =
    selectedTab === "broadcasts"
      ? "Add Your Scheduled Broadcast to Video Squirrel"
      : "Add Your First Video to Video Squirrel";

  const cardMessage =
    selectedTab === "broadcasts"
      ? "It all begins with you adding your amazing video schedules. Tap the “Add a Broadcast” button below, or at the top right of this screen to begin."
      : "It all begins with you adding your amazing videos. Tap the “Add a Video” button below, or at the top right of this screen to begin.";

  return (
    <div className={styles.firstProductPrompt}>
      <span className={styles.cardTitle}>{cardTitle}</span>
      <span className={styles.cardMessage}>{cardMessage}</span>
      <div className={styles.buttons}>
        <Button className="filled narrow" onClick={onAddVideoClick}>
          Add a {selectedTab === "broadcasts" ? "Broadcast" : "Video"}
        </Button>
      </div>
    </div>
  );
}

export default FirstVideoPrompt;
